import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { FaBookmark, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import list from "../../assets/images/list.png";
import { useNavigate } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import { CgFileDocument } from "react-icons/cg";
import { logEvent } from "../../utils/Analytics";
import urlText from "../urlText";

const StudentSavedjob = () => {
  // Opens job preview in new tab with sanitized URL
  const openPreviewPageInNewTab = (data) => {
    const sanitizedProfile = urlText(data?.profile);
    const sanitizedOpportunityType = urlText(data?.opportunityType);
    const sanitizedOrgName = urlText(data?.organisationName);
    const url = `/preview/${sanitizedProfile}-${sanitizedOpportunityType}-at-${sanitizedOrgName}_${data._id}`;
    window.open(url);
  };

  // Scrolls to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [matchedJobs, setMatchedJobs] = useState([]);
  const [jobData, setJobData] = useState("");
  const [count, setCount] = useState("");
  const [savedJobs, setSavedJobs] = useState("");
  const [page, setPage] = useState(1);
  const [forceRender, setForceRender] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Fetches all saved jobs from API
  const getSavedJobs = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get("/api/user/getSavedJobs", {
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token"),
        },
      });
      setSavedJobs(data.savedJobs);
      setCount(data.savedJobs.length);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Returns data for current page (15 items per page)
  const getCurrentPageData = () => {
    if (!savedJobs || !Array.isArray(savedJobs)) return [];
    const startIndex = (page - 1) * 15;
    const endIndex = startIndex + 15;
    return savedJobs.slice(startIndex, endIndex);
  };

  // Removes job from saved list
  const handleRemoveJob = async (jobId) => {
    try {
      const { data } = await axios.get(`/api/user/removeJob/${jobId}`, {
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token"),
        },
      });

      if (data.success) {
        setMatchedJobs((prevJobs) =>
          prevJobs.filter((job) => job._id !== jobId)
        );
        setForceRender((prev) => !prev);
      } else {
        console.log("Failed to remove job");
      }
    } catch (error) {
      console.error("Error in handleRemoveJob:", error);
    }
  };

  // Tracks analytics events for button clicks
  const handleAddEvent = (str) => {
    logEvent("Button", `Clicked ${str} button`);
  };

  // Navigates to next page if available
  const goToNextPage = () => {
    if (page < Math.ceil(count / 15)) {
      setPage(page + 1);
    }
  };

  // Navigates to previous page if available
  const goToPrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  // Fetches data when page changes or forceRender is triggered
  useEffect(() => {
    getSavedJobs();
    window.scrollTo(0, 0);
  }, [page, forceRender]);

  return (
    <div>
      <div className="my-applications" style={{ background: "white" }}>
        {loading ? (
          <>
            <div className="my-auto" style={{ textAlign: "center" }}>
              <p
                style={{
                  color: "#4B92C8",
                  fontWeight: "500",
                  marginTop: "-15px",
                  fontSize: "20px",
                  marginLeft: "43px",
                  marginBottom: "5px",
                }}
              >
                Loading..
              </p>
              <PropagateLoader
                color={"#4B92C8"}
                loading={true}
                size={15}
                aria-label="Loading Spinner"
                data-testid="loader"
                style={{ marginLeft: "27px" }}
              />
            </div>
          </>
        ) : (
          <>
            {savedJobs && savedJobs.length > 0 ? (
              <>
                <h2 className="title">Saved Jobs</h2>
                <div className="table-box table-responsive border">
                  <table className="applications table">
                    <thead>
                      <tr>
                        <th style={{ paddingLeft: "30px" }}>COMPANY</th>
                        <th style={{ paddingLeft: "30px" }}>PROFILE</th>
                        <th
                          className="studentSavedPadding"
                          style={{ width: "150px" }}
                        >
                          NUMBER OF <br />
                          APPLICANTS
                        </th>
                        <th
                          className="studentSavedPadding"
                          style={{ width: "150px" }}
                        >
                          VIEW JOB
                        </th>
                        <th
                          className="studentSavedPadding"
                          style={{ width: "150px" }}
                        >
                          REMOVE JOB
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(savedJobs) &&
                        getCurrentPageData().map((job, index) => (
                          <tr
                            key={index}
                            className="savedJobsTr"
                            style={{ borderLeft: "none", borderRight: "none" }}
                          >
                            <td className="" style={{ textAlign: "start" }}>
                              {job.organisationName}
                            </td>
                            <td
                              className=""
                              style={{
                                textAlign: "start",
                                minWidth: "250px",
                                maxWidth: "500px",
                              }}
                            >
                              {job.profile}
                            </td>
                            <td className="" style={{ textAlign: "center" }}>
                              {job.userApplied.length}
                            </td>
                            <td className="" style={{ textAlign: "center" }}>
                              <CgFileDocument
                                className="docIcon"
                                onClick={() => {
                                  openPreviewPageInNewTab(job);
                                  handleAddEvent("Preview job");
                                }}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                            <td className="" style={{ textAlign: "center" }}>
                              <FaBookmark
                                style={{
                                  marginLeft: "-20px",
                                  fontSize: "18px",
                                  color: "#0991DA",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleRemoveJob(job._id);
                                  handleAddEvent("Remove job");
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* COMPACT PAGINATION UI UPDATED TO MATCH UserApplications */}
{Math.ceil(count / 15) > 1 && (
  <div className="pagination">
    <div
      className="d-flex justify-content-center align-items-center flex-wrap"
      style={{ marginTop: "20px" }}
    >
      <a
        style={{
          cursor: "pointer",
          fontSize: "20px",
          color: page > 1 ? "#008bdc" : "#484848",
        }}
        onClick={() => {
          if (page > 1) goToPrevPage();
        }}
      >{`<`}</a>

      <span
        style={{
          color: "#484848",
          fontSize: "14px",
          // margin: "0 10px",
        }}
      >
        {page} / {Math.ceil(count / 15)}
      </span>

      <a
        style={{
          cursor: "pointer",
          fontSize: "20px",
          color: page < Math.ceil(count / 15) ? "#008bdc" : "#484848",
          // marginLeft: "10px",
        }}
        onClick={() => {
          if (page < Math.ceil(count / 15)) goToNextPage();
        }}
      >{`>`}</a>
    </div>
  </div>
)}


              </>
            ) : (
              <>
                <div className="text-center my-auto">
                  <i
                    className="fa fa-window-close-o mx-auto"
                    aria-hidden="true"
                    style={{ fontSize: "200px" }}
                  ></i>
                  <h1>Job not Found</h1>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StudentSavedjob;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaBookmark, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import PropagateLoader from "react-spinners/PropagateLoader";
// import { CgFileDocument } from "react-icons/cg";
// import { logEvent } from "../../utils/Analytics";
// import urlText from "../urlText";

// const StudentSavedjob = () => {
//   // Opens job preview in new tab with sanitized URL
//   const openPreviewPageInNewTab = (data) => {
//     const sanitizedProfile = urlText(data?.profile);
//     const sanitizedOpportunityType = urlText(data?.opportunityType);
//     const sanitizedOrgName = urlText(data?.organisationName);
//     const url = `/preview/${sanitizedProfile}-${sanitizedOpportunityType}-at-${sanitizedOrgName}_${data._id}`;
//     window.open(url);
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const [matchedJobs, setMatchedJobs] = useState([]);
//   const [savedJobs, setSavedJobs] = useState([]);
//   const [count, setCount] = useState(0);
//   const [page, setPage] = useState(1);
//   const [totalPage, setTotalPage] = useState(1);
//   const [forceRender, setForceRender] = useState(false);
//   const [loading, setLoading] = useState(true);

//   const navigate = useNavigate();

//   // Fetches all saved jobs from API
//   const getSavedJobs = async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get("/api/user/getSavedJobs", {
//         headers: {
//           "Content-Type": "application/json",
//           token: localStorage.getItem("token"),
//         },
//       });
//       setSavedJobs(data.savedJobs);
//       setCount(data.savedJobs.length);
//       setTotalPage(Math.ceil(data.savedJobs.length / 15));
//       setLoading(false);
//     } catch (error) {
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   // Returns data for current page (15 items per page)
//   const getCurrentPageData = () => {
//     if (!savedJobs || !Array.isArray(savedJobs)) return [];
//     const startIndex = (page - 1) * 15;
//     const endIndex = startIndex + 15;
//     return savedJobs.slice(startIndex, endIndex);
//   };

//   // Removes job from saved list
//   const handleRemoveJob = async (jobId) => {
//     try {
//       const { data } = await axios.get(`/api/user/removeJob/${jobId}`, {
//         headers: {
//           "Content-Type": "application/json",
//           token: localStorage.getItem("token"),
//         },
//       });

//       if (data.success) {
//         setMatchedJobs((prevJobs) =>
//           prevJobs.filter((job) => job._id !== jobId)
//         );
//         setForceRender((prev) => !prev);
//       } else {
//         console.log("Failed to remove job");
//       }
//     } catch (error) {
//       console.error("Error in handleRemoveJob:", error);
//     }
//   };

//   // Analytics tracker
//   const handleAddEvent = (str) => {
//     logEvent("Button", `Clicked ${str} button`);
//   };

//  useEffect(() => {
//   // Only fetch current page slice, not the whole list every time
//   getSavedJobs();
//   window.scrollTo(0, 0);
// }, [page, forceRender]);


//   return (
//     <div>
//       <div className="my-applications" style={{ background: "white" }}>
//         {loading ? (
//           <div className="my-auto" style={{ textAlign: "center" }}>
//             <p
//               style={{
//                 color: "#4B92C8",
//                 fontWeight: "500",
//                 marginTop: "-15px",
//                 fontSize: "20px",
//                 marginLeft: "43px",
//                 marginBottom: "5px",
//               }}
//             >
//               Loading..
//             </p>
//             <PropagateLoader
//               color={"#4B92C8"}
//               loading={true}
//               size={15}
//               aria-label="Loading Spinner"
//               data-testid="loader"
//               style={{ marginLeft: "27px" }}
//             />
//           </div>
//         ) : savedJobs && savedJobs.length > 0 ? (
//           <>
//             <h2 className="title">Saved Jobs</h2>
//             <div className="table-box table-responsive border">
//               <table className="applications table">
//                 <thead>
//                   <tr>
//                     <th style={{ paddingLeft: "30px" }}>COMPANY</th>
//                     <th style={{ paddingLeft: "30px" }}>PROFILE</th>
//                     <th style={{ width: "150px" }}>NUMBER OF <br /> APPLICANTS</th>
//                     <th style={{ width: "150px" }}>VIEW JOB</th>
//                     <th style={{ width: "150px" }}>REMOVE JOB</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {getCurrentPageData().map((job, index) => (
//                     <tr
//                       key={index}
//                       className="savedJobsTr"
//                       style={{ borderLeft: "none", borderRight: "none" }}
//                     >
//                       <td style={{ textAlign: "start" }}>
//                         {job.organisationName}
//                       </td>
//                       <td
//                         style={{
//                           textAlign: "start",
//                           minWidth: "250px",
//                           maxWidth: "500px",
//                         }}
//                       >
//                         {job.profile}
//                       </td>
//                       <td style={{ textAlign: "center" }}>
//                         {job.userApplied.length}
//                       </td>
//                       <td style={{ textAlign: "center" }}>
//                         <CgFileDocument
//                           className="docIcon"
//                           onClick={() => {
//                             openPreviewPageInNewTab(job);
//                             handleAddEvent("Preview job");
//                           }}
//                           style={{ cursor: "pointer" }}
//                         />
//                       </td>
//                       <td style={{ textAlign: "center" }}>
//                         <FaBookmark
//                           style={{
//                             marginLeft: "-20px",
//                             fontSize: "18px",
//                             color: "#0991DA",
//                             cursor: "pointer",
//                           }}
//                           onClick={() => {
//                             handleRemoveJob(job._id);
//                             handleAddEvent("Remove job");
//                           }}
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* ✅ UserApplications-style Pagination */}
//             {totalPage > 1 && (
//               <div className="pagination" style={{ marginTop: "20px" }}>
//                 <div className="d-flex justify-content-center align-items-center flex-wrap">
//                   {/* Left Arrow */}
//                   <FaChevronLeft
//                     style={{
//                       cursor: page > 1 ? "pointer" : "not-allowed",
//                       fontSize: "14px",
//                       color: "#484848",
//                       // marginRight: "10px",
//                     }}
//                     onClick={() => page > 1 && setPage(page - 1)}
//                   />

//                   {/* Page Display */}
//                   <span style={{ color: "#484848", fontSize: "14px", margin :"0px"}}>
//                     {page} / {totalPage}
//                   </span>

//                   {/* Right Arrow */}
//                   <FaChevronRight
//                     style={{
//                       cursor: page < totalPage ? "pointer" : "not-allowed",
//                       fontSize: "14px",
//                       color: "#484848",
//                       // marginLeft: "10px",
//                     }}
//                     onClick={() => page < totalPage && setPage(page + 1)}
//                   />
//                 </div>
//               </div>
//             )}
//           </>
//         ) : (
//           <div className="text-center my-auto">
//             <i
//               className="fa fa-window-close-o mx-auto"
//               aria-hidden="true"
//               style={{ fontSize: "200px" }}
//             ></i>
//             <h1>Job not Found</h1>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default StudentSavedjob;